import { render, staticRenderFns } from "./ModalError.vue?vue&type=template&id=13fc4a4d&scoped=true&"
import script from "./ModalError.vue?vue&type=script&lang=ts&"
export * from "./ModalError.vue?vue&type=script&lang=ts&"
import style0 from "./ModalError.vue?vue&type=style&index=0&id=13fc4a4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fc4a4d",
  null
  
)

export default component.exports